import { jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getColor } from '../../utils/colors.mjs';
import { typography, typographyColor, typographyLineHeight, typographyLineClamp, typographyWeight, typographySize } from './typography.vanilla.mjs';
import { parseEllipsis } from './utils/parseEllipsis.mjs';
import { parseFontSize } from './utils/parseFontSize.mjs';
import { parseFontWeight } from './utils/parseFontWeight.mjs';
import { parseLineHeight } from './utils/parseLineHeight.mjs';

const Typography = forwardRef(
  ({
    className: classNameFromProps,
    color,
    ellipsis,
    inherit,
    monospace,
    size,
    weight,
    lineHeight,
    style: styleFromProps,
    ...props
  }, forwardedRef) => {
    const className = classNames(
      typography({
        gradientText: color !== void 0 && isPresetGradientColor(color),
        ellipsis: ellipsis !== void 0 && ellipsis !== false,
        inherit,
        monospace
      }),
      classNameFromProps
    );
    const styles = Object.assign(
      {},
      assignInlineVars({
        [typographySize]: size !== void 0 ? parseFontSize(size) : null,
        [typographyWeight]: weight !== void 0 ? parseFontWeight(weight) : null,
        [typographyLineClamp]: ellipsis !== void 0 && ellipsis !== false ? parseEllipsis(ellipsis) : null,
        [typographyLineHeight]: lineHeight !== void 0 ? parseLineHeight(lineHeight) : null,
        [typographyColor]: color !== void 0 ? getColor(color) : null
      }),
      styleFromProps
    );
    return /* @__PURE__ */ jsx(
      StyledSpan,
      {
        "data-scope": "typography",
        "data-part": "root",
        className,
        style: styles,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
const StyledSpan = styled(Primitive.span);
Typography.displayName = "Typography";
Typography.toString = () => '[data-scope="typography"][data-part="root"]';

export { Typography };
//# sourceMappingURL=Typography.mjs.map
